module.exports = __webpack_public_path__ + "img/gift_icon.beb1623c.png";